import { render } from "./DefaultTopics.vue?vue&type=template&id=fa070038&scoped=true"
import script from "./DefaultTopics.vue?vue&type=script&lang=js"
export * from "./DefaultTopics.vue?vue&type=script&lang=js"

import "./DefaultTopics.vue?vue&type=style&index=0&id=fa070038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa070038"]])

export default __exports__